<clr-modal [clrModalOpen]="open" (clrModalOpenChange)="close()" [clrModalSize]="'md'">
  <h3 class="modal-title">Automatic theme switch</h3>
  <div class="modal-body">
    <p class="schedule-explanation">
      Every day, NetScope uses the light theme between the two handles and the dark theme the rest of the time.
      Times follow your browser's time zone. This choice is kept in this browser only.
    </p>

    <fieldset class="schedule-fieldset">
      <legend class="clr-control-label">Daily schedule</legend>
      <div class="schedule-slider">
        <!-- Time labels above the handles (the sliders give the same values to screen readers) -->
        <div class="handle-label" aria-hidden="true" [style.left]="handleLabelPosition(lightAt)">{{ formatTime(lightAt) }}</div>
        <div class="handle-label" aria-hidden="true" [style.left]="handleLabelPosition(darkAt)">{{ formatTime(darkAt) }}</div>

        <!-- The whole day: dark segments outside the handles, light segment between them -->
        <div class="day-bar" aria-hidden="true">
          <div class="night-segment" [style.left.%]="0" [style.width.%]="morningNightWidth"></div>
          <div class="night-segment" [style.left.%]="percentOfDay(darkAt)" [style.width.%]="eveningNightWidth"></div>
          <cds-icon shape="sun" class="bar-icon sun-icon" size="14" [style.left.%]="percentOfDay((lightAt + darkAt) / 2)"></cds-icon>
          @if (showMorningMoon) {
            <cds-icon shape="moon" class="bar-icon moon-icon" size="14" [style.left.%]="morningNightWidth / 2"></cds-icon>
          }
          @if (showEveningMoon) {
            <cds-icon shape="moon" class="bar-icon moon-icon" size="14" [style.left.%]="100 - eveningNightWidth / 2"></cds-icon>
          }
          <div class="now-marker" [style.left.%]="percentOfDay(nowMinutes)"></div>
        </div>

        <!-- Two native sliders on top of each other: only their handles catch the mouse (see the CSS) -->
        <input type="range" min="0" [max]="maximumTime" step="15" [value]="lightAt"
               (input)="onLightSliderInput($event)"
               aria-label="Switch to light theme at" [attr.aria-valuetext]="formatTime(lightAt)">
        <input type="range" min="0" [max]="maximumTime" step="15" [value]="darkAt"
               (input)="onDarkSliderInput($event)"
               aria-label="Switch to dark theme at" [attr.aria-valuetext]="formatTime(darkAt)">
      </div>
      <div class="hour-ticks" aria-hidden="true">
        @for (hour of hourTicks; track hour) {
          <span [style.left.%]="percentOfDay(hour * 60)">{{ hour.toString().padStart(2, '0') }}</span>
        }
      </div>
    </fieldset>

    <div class="clr-row schedule-times">
      <div class="clr-col-6 clr-form-control">
        <label for="theme-light-time" class="clr-control-label">Light theme from</label>
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input id="theme-light-time" class="clr-input" type="time" step="900"
                   [value]="formatTime(lightAt)" (change)="onLightTimeChange($event)">
          </div>
        </div>
      </div>
      <div class="clr-col-6 clr-form-control">
        <label for="theme-dark-time" class="clr-control-label">Dark theme from</label>
        <div class="clr-control-container">
          <div class="clr-input-wrapper">
            <input id="theme-dark-time" class="clr-input" type="time" step="900"
                   [value]="formatTime(darkAt)" (change)="onDarkTimeChange($event)">
          </div>
        </div>
      </div>
    </div>

    <p class="schedule-summary" aria-live="polite">
      Light for {{ formatDuration(lightDuration) }}, dark for {{ formatDuration(darkDuration) }}.
      Now ({{ formatTime(nowMinutes) }}): {{ isLightNow ? 'light' : 'dark' }} theme.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</clr-modal>
